<template>
  <section class="pageInner">
    <spinner full v-if="loading"/>
    <header>
      <template v-if="termoRead">
        <h4>Leia com atenção o termo abaixo</h4>
        <p>Na próxima etapa, você deverá assinar o termo para prosseguir com o checkout</p>
      </template>
      <template v-if="termoSign">
        <h4>Assine o termo</h4>
        <p>Assine todos os campos com seu nome. Se necessário, arraste a assinatura para a área correta</p>
      </template>
      <template v-if="termoSigned">
        <h4>Tudo certo!</h4>
        <p>Você será redirecionado para o checkout automaticamente</p>
      </template>
    </header>
    <div class="termo-read" v-if="termoRead && !loading">
      <div :class="{wait: !fileURL}">
        <vue-pdf-embed v-if="fileURL" :source="fileURL" />
        <template v-else>
          <span class="termoError" v-if="termoError">
            <fa :icon="['fal', 'triangle-exclamation']" class="icon"/>
            <h5>{{ termoError }}</h5>
          </span>
          <spinner v-else />          
        </template>
      </div>
    </div>
    <div class="assinatura-wrapper" v-else-if="termoSign && !loading">
      <div v-if="loading">Carregando documento para assinatura...</div>
      <iframe
        v-if="signingUrl"
        :src="signingUrl"
        class="docusign-frame"
      ></iframe>
      <div v-if="error" class="text-danger mt-3">{{ error }}</div>
    </div>
    <div v-else-if="termoSigned && !loading">
      <div class="checkmark-container">
        <svg viewBox="0 0 52 52" class="checkmark">
          <circle class="checkmark__circle" cx="26" cy="26" r="22" fill="none" />
          <path class="checkmark__check" fill="none" d="M14 27l7 7 16-16" />
        </svg>
      </div>
      <p class="timer">00:{{ timeToLeave }}</p>
    </div>
    <footer v-if="termoRead && !loading">
      <button-nav @onClick="getContrato()">
        Tudo certo! Assinar termo
      </button-nav>
    </footer>
  </section>
</template>

<script>
import NegociaService from '@/services/negocieja.service.js'
import VuePdfEmbed from 'vue-pdf-embed'
import ButtonNav from '@/components/financeiro/negocieja/app/navigation/ButtonNav.vue'
import Spinner from '@/components/financeiro/negocieja/app/utilities/Spinner.vue'

export default {
  components:{
    VuePdfEmbed, ButtonNav, Spinner
  },
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    },
    steps: {
      type: Array
    },
    debitos: {
      type: Object
    },
    idProposta: {
      type: [String, Number]
    }
  },
  data () {
    return {
      signingUrl: null,
      loading: false,
      error: null,
      termoRead: true,
      termoSign: false,
      termoSigned: false,
      fileURL: null,
      envelopeId: null,
      timeToLeave: '03',
      timer: null,
      contrato: null,
      termoError: null,
      proposta: null
    }
  },
  mounted () {
    window.addEventListener('message', this.handleMessage)

    this.$store.dispatch('negocieja/get').then(response => {
      console.log("negocieja termo:", response)
      this.proposta = response

      if ( this.idProposta ) {
        this.getProposta()
        this.proposta.termo.uuid = this.idProposta
      }
      // this.matricula = response
    })
    
  },
  beforeUnmount () {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    getProposta () {
      this.loading = true
      NegociaService.getProposta(this.idProposta).then(
        response => {
          console.log("getProposta:", response.data)
          this.fileURL = `data:application/pdf;base64,${response.data.pdf}`
          this.proposta.termo.JSON = response.data.pdf
          this.proposta.proposta = response.data.dados
          this.loading = false
        }
      ).catch(
        error => {
          console.error(error)
          this.termoError = error.response.data.error
        }
      ).finally(() => {
        this.loading = false
      })
    },
    getContrato () {
      this.loading = true

      NegociaService.getContrato( this.idProposta ).then(
        response => {
          console.log("getContrato", response.data)
          this.proposta.termo.contrato = response.data

          this.envelopeId = response.data.envelopeId
          this.signContrato()
        }
      )
    },
    signContrato () {
      NegociaService.signContrato( this.envelopeId ).then(
        response => {
          console.log("signContrato", response.data)
          this.contrato = response.data
          this.signingUrl = this.contrato.original.url
          this.termoRead = false
          this.termoSign = true
          this.loading = false
          this.proposta.termo.url = this.signingUrl
        }
      )
    },
    handleMessage ( event ) {
      if (event.data && event.data.type === 'DOCUSIGN_FINISHED') {
        this.termoSign = false
        this.termoSigned = true
        this.proposta.termo.assinatura = 'sim'
        this.runTimer()
      }
    },
    runTimer () {
      var ini = 3
      this.timer = setInterval(() => {
        ini--
        this.timeToLeave = ini.toString().padStart(2, '0')

        if ( ini === 0 ) {
          clearInterval(this.timer)
          // this.$router.push({ name: 'negociejaApp', params: { session: 'negociar', step: 'checkout' }})
          this.$emit('onNext', this.contrato)
        }
      },1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .pageInner {
    color: $preto-2;
    z-index: 5;
    display: flex; flex-direction: column;
    overflow: hidden;
    height: 100%;

    >header {
      padding: $hmg_mid 40px;
      
      >h4 {
        max-width: 540px;
        z-index: 3;
        flex-shrink: 0; 
      }

      p {
        margin-bottom: 0;
      }
      
    }

    >div {
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      flex-shrink: 0;
      height: 100%;
      flex: 1;
      max-height: 100%;
      border-radius: $border-radius-large;
      @extend %transition_4e;
      min-height: 300px;
      background-color: $color-secondary;

      >h4 {
        max-width: 540px;
        z-index: 3;
        flex-shrink: 0; 
        text-align: center;
        padding: 40px;
      }

      &.termo-read {
        .wait {
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          width: 100%; height: 100%;
        }
      }
    }

    footer {
      padding: $hmg_large;
      position: relative;

      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }
    }
  }
  
  .checkmark-container {
    width: 180px;
    height: 180px;
    display: block;
    margin: 1rem auto;
    background-color: transparent;
  }

  .checkmark {
    width: 100%;
    height: 100%;
    stroke-width: 6;
    stroke: $color-success;
    stroke-miterlimit: 10;
    box-sizing: border-box;

    &__circle {
      stroke-dasharray: 157;
      stroke-dashoffset: 157;
      animation: draw-circle 0.6s ease-out forwards;
    }

    &__check {
      stroke-dasharray: 36;
      stroke-dashoffset: 36;
      animation: draw-check 0.3s 0.6s ease-out forwards;
    }
  }

  @keyframes draw-circle {
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes draw-check {
    to {
      stroke-dashoffset: 0;
    }
  }

  .docusign-frame {
    height: 100%;
  }
  
  .timer {
    display: block;
    padding: $hmg_small;
    border-radius: $border-radius;
    background-color: $color-secondary;
    text-align: center;
    width: 80px;
    margin: $hmg_mid auto;
    font-size: 1.4rem;
    line-height: 1;
  }

  .termoError {
    max-width: 60%;
    text-align: center;

    .icon {
      font-size: 64px;
      color: $color-warning;
      margin-bottom: $hmg_mid;
    }
  }
</style>